import React from "react";
import {Link} from "react-router-dom";
import {crmApiBaseUrl} from "../Config";

// CRM'den tek tıkla giriş: adres çubuğundaki #t=<bilet> parçasını CRM API'ye sorar, dönen oturum bilgisini
// normal girişteki gibi (Lib/Authorization.js doLogin) localStorage'a "auth_" önekiyle yazar ve panele geçer.
// Bilet tek kullanımlıktır ve adres parçasında olduğu için sunucu günlüklerine düşmez; okunur okunmaz adresten silinir.
class Sso extends React.Component {
    state = {error: null}

    componentDidMount() {
        const ticket = new URLSearchParams(window.location.hash.replace(/^#/, "")).get("t");
        window.history.replaceState(null, "", window.location.pathname);
        if (!ticket) {
            this.setState({error: "Giriş bileti bulunamadı. CRM'den tekrar açın."});
            return;
        }
        fetch(crmApiBaseUrl + "/sso/license-login", {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify({ticket})
        }).then(r => r.json().then(data => ({ok: r.ok, data}))).then(({ok, data}) => {
            if (!ok || typeof data.id === "undefined") {
                this.setState({error: data.message || "Giriş yapılamadı. CRM'den tekrar açın."});
                return;
            }
            Object.keys(data).forEach(key => localStorage.setItem("auth_" + key, data[key]));
            this.props.history.replace("/dashboard");
        }).catch(() => this.setState({error: "CRM'e ulaşılamadı. Biraz sonra tekrar deneyin."}));
    }

    render() {
        const {error} = this.state;
        return <div className="container-fluid" style={{padding: "80px 20px", textAlign: "center"}}>
            {error ? <div>
                <p>{error}</p>
                <Link className="btn btn-primary" to="/login">Giriş sayfasına git</Link>
            </div> : <p>CRM ile giriş yapılıyor…</p>}
        </div>;
    }
}

export default Sso;
